import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import DatePicker from 'react-datepicker2';
import SelectAsync from 'react-select/async';

export default class SolutionTask extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            solutionId: props.SolutionId,
            caller: props.Caller,
            data: null,
            loading: true,
            attachment: '',
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    setAttachment(_attachment) {
        var ext = _attachment.type;
        if (ext == "image/webp" || ext == "image/gif" || ext == "image/png" ||
            ext == "image/jpeg" || ext == "image/jpg" || ext == "application/pdf"
            || ext == "application/vnd.ms-word" || ext == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || ext == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            || ext == "application/vnd.ms-excel" || ext == "application/x-zip-compressed") {
            this.getBase64(_attachment).then(attachment => {
                this.state.attachment = attachment;
            });
        }
        else {
            this.showErorrMessage("فرمت فایل انتخاب شده نامعتبر است");
        }

    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/solution/task/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();

        if (this.isBlank(this.state.data.record.estimatedTime)) this.state.data.record.estimatedTime = 0;
        this.state.data.record.estimatedTime = parseInt(this.state.data.record.estimatedTime);

        this.httpPost("api/v1/solution/task/save", {
            id: this.state.id,
            description: this.state.data.record.description,
            workFlowId: this.state.data.record.workFlowId,  
            workFlowFlowType: this.state.data.record.workFlowFlowType,  
            alarmDate: this.convertMomentToDb(this.state.data.record.alarmDate),
            solutionId: this.state.solutionId,
            estimatedTime: this.state.data.record.estimatedTime,
            title: this.state.data.record.title,
            priorityId: this.state.data.record.priorityId,
            attachment: this.state.attachment,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setWorkFlow(e) {
        this.state.data.record.workFlowId = e.value;
        this.state.data.record.workFlowName = e.label;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width":"90%"}}>
                    <div className="modal-content">
                        <div className="modal-body" style={{ "padding": "0" }}>
                            <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">
                                    {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات وظیفه" : "افزودن وظیفه جدید"}
                                </h4>
                            </div>
                            <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان</label><span className="red">*</span>
                                            <textarea defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm"></textarea>
                                        </div>
                                    </div>
                                </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="form-group">
                                            <label for="name" className="title1">شرح وظیفه</label><span className="red">*</span>
                                            <textarea style={{ "height":"160px"}} defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} autocomplete="off" type="text" className="form-control input-sm"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">گردش کاری</label><span className="red">*</span>
                                            {this.state.data.record.id == this.getDefaultGuid() ?
                                                <SelectAsync
                                                    defaultValue={this.state.data.record.workFlowId != this.getDefaultGuid() ? [{ value: this.state.data.record.workFlowId, label: this.state.data.record.workFlowName }] : null}
                                                    isMulti={false}
                                                    placeholder="انتخاب گردش کاری"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadSolutionWorkFlowsOptions(inputValue, callback, this.state.solutionId)}
                                                    onChange={e => this.setWorkFlow(e)}
                                                />
                                                :
                                                <p>{this.state.data.record.workFlowName}</p>
                                            }
                                        </div>
                                    </div>
                                    {1 === 2 && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">نحوه تخصیص گردش کاری</label><span className="red">*</span>
                                            {this.state.data.record.id == this.getDefaultGuid() ?
                                                <select defaultValue={this.state.data.record.workFlowFlowType} onChange={e => this.state.data.record.workFlowFlowType = parseInt(e.target.value)} autocomplete="off" className="form-control input-sm">
                                                    <option value="1">خطی-یک گردش کاری برای همه مجریان</option>
                                                    <option value="2">موازی-گردش کاری اختصاصی هر مجری</option>
                                                </select>
                                                : [
                                                    this.state.data.record.workFlowFlowType === 1 && <p> خطی - یک گردش کاری برای همه مجریان</p>,
                                                    this.state.data.record.workFlowFlowType === 2 && <p>موازی-گردش کاری اختصاصی هر مجری</p>,
                                                ]}
                                        </div>
                                    </div>}
                                    {1 === 2 && <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">تاریخ یادآوری</label>
                                            <DatePicker
                                                inputReadOnly={true}
                                                className="form-control input-sm persian-date"
                                                placeholder={"تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.state.data.record.alarmDate = e }}
                                                value={this.getFormatedDateForDatePicker(this.state.data.record.alarmDate)}
                                            />
                                        </div>
                                    </div>}
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">مدت زمان تقریبی انجام</label><span className="red"> (دقیقه)</span>
                                            <input type="text" defaultValue={this.state.data.record.estimatedTime} onChange={e => this.state.data.record.estimatedTime = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">اولویت</label>
                                            <select defaultValue={this.state.data.record.priorityId} onChange={e => this.state.data.record.priorityId = parseInt(e.target.value)} autocomplete="off" className="form-control input-sm">
                                                <option value="1">عادی</option>
                                                <option value="2">فوری</option>
                                                <option value="3">کم</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="form-group">
                                            <label className="form-label">فایل پیوست</label>
                                            <div className="form-control-wrap">
                                                <input type="file" onChange={(e) => { this.setAttachment(e.target.files[0]) }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                    ذخیره
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}